import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Global scroll restoration. Resets scroll position to the top on every route change.
 * If a hash is present (e.g. /global-link#apply), scrolls smoothly to that anchor instead.
 * Renders nothing.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait a tick so the new page has mounted its DOM before locating the anchor.
      const t = window.setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }
      }, 60);
      return () => window.clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
